// Araçlar (ToolsPanel) popover'ının konumu — saf hesap, DOM okumaz.
//
// Popover önce ikon şeridinin hemen altına, şeridin sağ kenarına hizalı açılır.
// Alt sınır timeline dock'unun üst kenarıdır (#timelineDock, #mainRow'un altına
// absolute oturur); yalnız viewport'a göre sınırlamak kısa ekranlarda popover'ı
// timeline'ın üstüne bindiriyordu. Şeridin altında yeterli yer yoksa popover
// şeridin SOLUNA açılır — yukarı kaydırmak şeridi (ve kendi toggle butonunu)
// örterdi.
//
// `side: true` (Kırp) popover'ı yer olsa bile doğrudan şeridin soluna, ikon
// kartının üst kenarıyla hizalı dar bir dikey sütun olarak açar — sağ panele
// paralel.

const POPOVER_MARGIN = 12;
const POPOVER_GAP = 8;
const POPOVER_MAX_HEIGHT = 360;
const POPOVER_MIN_HEIGHT = 220;
const FALLBACK_TOP = 120;
const FALLBACK_RIGHT = 88;
// #toolsPanelDrawer kartının şeridi saran padding'i (EditorApp.jsx).
const STRIP_CARD_PAD = 6;

export function computeToolsPopoverPlacement({
  stripRect,
  timelineTop,
  viewportWidth,
  viewportHeight,
  side = false,
}) {
  const viewportBottom = viewportHeight - POPOVER_MARGIN;
  const bottomLimit =
    timelineTop != null ? Math.min(viewportBottom, timelineTop - POPOVER_MARGIN) : viewportBottom;

  const belowTop = stripRect ? stripRect.bottom + POPOVER_GAP : FALLBACK_TOP;
  const fitsBelow = bottomLimit - belowTop >= POPOVER_MIN_HEIGHT;

  let top;
  let right;
  if (!stripRect) {
    top = fitsBelow ? belowTop : Math.max(POPOVER_MARGIN, bottomLimit - POPOVER_MIN_HEIGHT);
    right = FALLBACK_RIGHT;
  } else if (side) {
    // Kartın soluna, üst kenarı kartla hizalı; timeline'a sığmıyorsa yukarı kaydır.
    const cardTop = stripRect.top - STRIP_CARD_PAD;
    top = Math.max(POPOVER_MARGIN, Math.min(cardTop, bottomLimit - POPOVER_MIN_HEIGHT));
    right = Math.round(viewportWidth - (stripRect.left - STRIP_CARD_PAD) + POPOVER_GAP);
  } else if (fitsBelow) {
    top = belowTop;
    right = Math.max(POPOVER_MARGIN, Math.round(viewportWidth - stripRect.right));
  } else {
    // Şeridin yanına: üstü şeritle hizalı; timeline'a kadar en az MIN_HEIGHT
    // kalmıyorsa yukarı kaydır (ama viewport'un üstünden taşma).
    top = Math.max(POPOVER_MARGIN, Math.min(stripRect.top, bottomLimit - POPOVER_MIN_HEIGHT));
    right = Math.round(viewportWidth - stripRect.left + POPOVER_GAP);
  }

  // Timeline ekranın neredeyse tamamını kaplıyorsa (dock çok yukarı sürüklenmiş)
  // tamamen kullanılamaz bir popover yerine viewport'a sığan asgari yüksekliği ver.
  const available = bottomLimit - top;
  const maxHeight = Math.min(
    POPOVER_MAX_HEIGHT,
    available >= POPOVER_MIN_HEIGHT ? available : Math.min(POPOVER_MIN_HEIGHT, viewportBottom - top)
  );

  return { top, right, maxHeight };
}
